import React, { Component } from "react";
import AutocompleteTextfieldApi from "./AutocompleteTextfieldApi";
import { Element } from "cw-styleguide-react";

class AutocompleteTextfieldApiElement extends Component {
  render() {
    return (
      <Element
        {...this.props}
        group_classes={["form__autocomplete-search", "js-autocomplete-search"]}
        type="textfield"
      >
        <AutocompleteTextfieldApi
          prefix={this.props.prefix}
          suffix={this.props.suffix}
          hasButton={this.props.hasButton}
          anchorId={this.props.anchorId}
          name={this.props.name}
          id={this.props.id}
          value={this.props.value}
          keyword={this.props.keyword}
          placeholder={this.props.placeholder}
          acceptLanguage={this.props.acceptLanguage}
          disabled={this.props.disabled}
          onChange={this.props.onChange}
          onSelected={this.props.onSelected}
          keyField={this.props.keyField}
          valueField={this.props.valueField}
          authorize={this.props.authorize}
          maxLength={this.props.maxLength}
          type={this.props.type}
          required={this.props.required}
          api={this.props.api}
          queryParameter={this.props.queryParameter}
          additionalParameters={this.props.additionalParameters}
          dataFields={this.props.dataFields}
        />
      </Element>
    );
  }
}

export default AutocompleteTextfieldApiElement;
